<template>
  <el-form ref="form" :model="form" label-width="150px">
    <el-form-item label="总价">
      ￥{{ form.total_amount }}
    </el-form-item>
    <el-form-item label="订单状态">
      <el-tag v-if="form.status==0" type="danger">已取消</el-tag>
      <el-tag v-if="form.status==1" type="success">已进件</el-tag>
      <el-tag v-if="form.status==2" type="warning">等待签署合同</el-tag>
      <el-tag v-if="form.status==3" >履约中</el-tag>
      <el-tag v-if="form.status==4" type="success">履约完成</el-tag>
    </el-form-item>
    <el-form-item label="代扣签约状态">
      {{ form.sign_withhold_status }}
    </el-form-item>
    <el-form-item  label="">
      <el-table :data="form.termInfo">
        <el-table-column label="期数" prop="expect"></el-table-column>
        <el-table-column label="付款时间" prop="pay_date"></el-table-column>
        <el-table-column label="每期" prop="month_price"></el-table-column>
        <el-table-column label="账单状态" prop="status">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.status==0" type="warning">未支付</el-tag>
            <el-tag v-if="scope.row.status==1" type="success">已支付</el-tag>
            <el-tag v-if="scope.row.status==2" type="danger">支付失败</el-tag>
            <el-tag v-if="scope.row.status==3" type="warning">拒绝支付</el-tag>
            <el-tag v-if="scope.row.status==4" type="info">取消支付</el-tag>
            <el-tag v-if="scope.row.status==5" >已退款</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="是否提前还款" prop="is_advance">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.is_advance==0" type="warning">否</el-tag>
            <el-tag v-if="scope.row.is_advance==1" type="success">是</el-tag>
          </template>
        </el-table-column>
      </el-table>
      <!-- <div v-for="(item,index) in form.termInfo">
        <div>第{{ item.expect }}期</div>
        <div>付款时间：{{ item.pay_date }}</div>
        <div>每期：￥{{ item.month_price }}</div>
        <div>账单状态：
          <el-tag v-if="item.status==0" type="warning">未支付</el-tag>
          <el-tag v-if="item.status==1" type="success">已支付</el-tag>
          <el-tag v-if="item.status==2" type="danger">支付失败</el-tag>
          <el-tag v-if="item.status==3" type="warning">拒绝支付</el-tag>
          <el-tag v-if="item.status==4" type="info">取消支付</el-tag>
          <el-tag v-if="item.status==5" >已退款</el-tag>
        </div>
        <div>是否提前还款：{{ item.is_advance==0 ? '否' :'是' }}</div>
      </div> -->
    </el-form-item>
  </el-form>
</template>
<script>
export default {
  data(){
    return {
      form:{

}
    }
  },
  props:{
    OrderStatusDetail:{
      type:Object,
      default:()=>{}
    }
  },
  watch:{
    OrderStatusDetail:{
      handler(val){
        this.form = val
      },
      immediate:true
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/views/order/order/dialog/orderStatus.vue